import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TalentTestPage.css';
import '../styles/components/button.css';
import { talentQuestions } from '../data/talentTestQuestions';

const talents = Object.keys(talentQuestions);

const TalentTestPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState<{ [key: string]: number }>({});
  

  useEffect(() => {
    const initialAnswers: { [key: string]: number } = {};
    talents.forEach((talent, tIndex) => {
        const questions = talentQuestions[talent as keyof typeof talentQuestions];
        questions.forEach((_, qIndex) => {
            initialAnswers[`q${tIndex}_${qIndex}`] = 0;
        });
    });
    setAnswers(initialAnswers);
  }, []);

  const selectAnswer = (questionId: string, value: number) => {
    setAnswers(prev => ({ ...prev, [questionId]: value }));
  };

  const prevTalent = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };

  const nextTalent = () => {
    if (currentIndex < talents.length - 1) {
      setCurrentIndex(prev => prev + 1);
    } else {
      const calculatedScores: { [key: string]: number } = {};
      talents.forEach((talent, tIndex) => {
        const questions = talentQuestions[talent as keyof typeof talentQuestions];
        let total = 0;
        questions.forEach((_, qIndex) => {
          const answer = answers[`q${tIndex}_${qIndex}`] || 0;
          total += answer;
        });
        calculatedScores[talent] = total;
      });
      
      const sortedTalents = Object.entries(calculatedScores).sort(([, a], [, b]) => b - a);
      // 将本次测试的排序结果持久化到浏览器，便于重启后恢复
      try {
        localStorage.setItem('talent_last_sortedTalents', JSON.stringify(sortedTalents));
        localStorage.setItem('talent_last_savedAt', Date.now().toString());
      } catch (e) {
        console.warn('无法写入本地缓存（sortedTalents）:', e);
      }
      navigate('/talent-test-result', { state: { sortedTalents } });
    }
  };



  const currentTalentName = talents[currentIndex];
  const questions = talentQuestions[currentTalentName as keyof typeof talentQuestions];
  const currentTalentDisplayName = `才干 ${currentIndex + 1}`;

  return (
    <div className="talent-test-page-container">
      <div className="talent-section">
        <h1 id="currentTalent">{currentTalentDisplayName}</h1>
        <div id="questionsContainer">
          {questions.map((question, qIndex) => {
            const questionId = `q${currentIndex}_${qIndex}`;
            return (
              <div className="question-box" key={questionId}>
                <div className="question-text">{question}</div>
                <div className="options-container">
                  {[0, 1, 2].map(value => (
                    <div
                      key={value}
                      className={`option-btn ${answers[questionId] === value ? 'selected' : ''}`}
                      onClick={() => selectAnswer(questionId, value)}
                    >
                      {value}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        <div className="nav-buttons">
          <button id="prevBtn" onClick={prevTalent} disabled={currentIndex === 0} className="btn-secondary">
            上一组
          </button>
          <button id="nextBtn" onClick={nextTalent} className="btn-primary">
            {currentIndex === talents.length - 1 ? '完成' : '下一组'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TalentTestPage;